import React, { useEffect, useState } from 'react'

import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CFormSelect,
  CRow,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBan, cilStorage, cilFolderOpen, cilApplications } from '@coreui/icons'

import { useDispatch, useSelector } from 'react-redux'
import { getDashboard } from 'src/redux/dashboard'
import { useNavigate } from 'react-router-dom'

const Dashboard = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1) // Default: Current Month
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()) // Default: Current Year

  const [formData, setFormData] = useState({ orders: 'Today' })

  const dispatch = useDispatch()
  const history = useNavigate()

  const {
    totalOrders,
    pendingOrders,
    cancelledOrders,
    completedOrders,

    todayOrders,
    todayPendingOrders,
    todayCancelledOrders,
    todayCompletedOrders,

    weeklyOrders,
    weeklyPendingOrders,
    weeklyCancelledOrders,
    weeklyCompletedOrders,

    monthlyOrders,
    monthlyPendingOrders,
    monthlyCancelledOrders,
    monthlyCompletedOrders,

    yearlyOrders,
    yearlyPendingOrders,
    yearlyCancelledOrders,
    yearlyCompletedOrders,

    totalUsers,
    todayRegistrations,
    monthlyRegistrations,
    currentYearRegistrations,
    previousYearRegistrations,

    totalProducts,
    outOfStock,
    categories,
    subCategories,
    productDetails,

    // loadingDashboard,
    // errorDashboard,
  } = useSelector((state) => state.admindashboard)

  useEffect(() => {
    const body = {
      month: selectedMonth,
      year: selectedYear,
    }
    dispatch(getDashboard(body))
  }, [dispatch, selectedMonth, selectedYear])

  const getOrderData = () => {
    switch (formData.orders) {
      case 'Week':
        return {
          orders: weeklyOrders,
          pending: weeklyPendingOrders,
          cancelled: weeklyCancelledOrders,
          completed: weeklyCompletedOrders,
        }
      case 'Month':
        return {
          orders: monthlyOrders,
          pending: monthlyPendingOrders,
          cancelled: monthlyCancelledOrders,
          completed: monthlyCompletedOrders,
        }
      case 'Year':
        return {
          orders: yearlyOrders,
          pending: yearlyPendingOrders,
          cancelled: yearlyCancelledOrders,
          completed: yearlyCompletedOrders,
        }
      case 'Today':
      default:
        return {
          orders: todayOrders,
          pending: todayPendingOrders,
          cancelled: todayCancelledOrders,
          completed: todayCompletedOrders,
        }
    }
  }

  const { orders, pending, cancelled, completed } = getOrderData()

  return (
    <>
      <CCard className="mb-2 shadow">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title m-3">👤 Registration Details</h5>
          <div className="m-3 d-flex gap-2">
            <CFormSelect
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(Number(e.target.value))}
              className="w-auto"
            >
              {[
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
              ].map((month, index) => (
                <option key={index + 1} value={index + 1}>
                  {month}
                </option>
              ))}
            </CFormSelect>

            <CFormSelect
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
              className="w-auto"
            >
              {[2024, 2025, 2026, 2027, 2028, 2029, 2030].map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </CFormSelect>
          </div>
        </div>
        <CCardBody>
          <CRow>
            <CCol sm={2}>
              <div className="border border-primary rounded-3 p-3 shadow-sm">
                <div className="text-primary small">Total Users</div>
                <div className="fs-5 fw-semibold">{totalUsers}</div>
              </div>
            </CCol>
            <CCol sm={2}>
              <div className="border border-success rounded-3 p-3 shadow-sm">
                <div className="text-success small">Today’s Registrations</div>
                <div className="fs-5 fw-semibold">{todayRegistrations}</div>
              </div>
            </CCol>
            <CCol sm={2}>
              <div className="border border-info rounded-3 p-3 shadow-sm">
                <div className="text-info small">Monthly Registrations</div>
                <div className="fs-5 fw-semibold">{monthlyRegistrations}</div>
              </div>
            </CCol>
            <CCol sm={3}>
              <div className="border border-warning rounded-3 p-3 shadow-sm">
                <div className="text-warning small">Current Year Registrations</div>
                <div className="fs-5 fw-semibold">{currentYearRegistrations}</div>
              </div>
            </CCol>
            <CCol sm={3}>
              <div className="border border-danger rounded-3 p-3 shadow-sm">
                <div className="text-danger small">Previous Year Registrations</div>
                <div className="fs-5 fw-semibold">{previousYearRegistrations}</div>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard className="mb-2 shadow">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title m-3">📦 All Orders{' & '}History</h5>
          <CFormSelect
            className="w-auto m-3"
            value={formData.orders}
            onChange={(e) => setFormData({ ...formData, orders: e.target.value })}
            required
          >
            {['Today', 'Week', 'Month', 'Year']?.map((item, index) => (
              <option value={item} key={index}>
                {item} Orders History
              </option>
            ))}
          </CFormSelect>
        </div>

        <CCardBody>
          <CRow>
            <CCol xs={12} md={6} xl={6}>
              <CRow>
                <CCol sm={6}>
                  <div className="border-start border-start-4 border-start-info py-1 px-3">
                    <CButton
                      color="outline-info"
                      className="mx-0"
                      size="sm"
                      onClick={() => history(`/orders/all`)}
                    >
                      Total Orders
                    </CButton>

                    <div className="fs-5 fw-semibold">{totalOrders}</div>
                  </div>
                </CCol>
                <CCol sm={6}>
                  <div className="border-start border-start-4 border-start-danger py-1 px-3 mb-3">
                    <CButton
                      color="outline-danger"
                      className="mx-0"
                      size="sm"
                      onClick={() => history(`/orders/cancelled`)}
                    >
                      Cancelled Orders
                    </CButton>
                    <div className="fs-5 fw-semibold">{cancelledOrders}</div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm={6}>
                  <div className="border border-2 border-info py-1 px-3">
                    <div className="text-info small">{formData?.orders} Total Orders</div>
                    <div className="fs-5 fw-semibold">{orders}</div>
                  </div>
                </CCol>
                <CCol sm={6}>
                  <div className="border border-2 border-danger py-1 px-3 mb-3">
                    <div className="text-danger small">{formData?.orders} Cancelled Orders</div>
                    <div className="fs-5 fw-semibold">{cancelled}</div>
                  </div>
                </CCol>
              </CRow>
            </CCol>

            <CCol xs={12} md={6} xl={6}>
              <CRow>
                <CCol sm={6}>
                  <div className="border-start border-start-4 border-start-warning py-1 px-3 mb-3">
                    <CButton
                      color="outline-warning"
                      className="mx-0"
                      size="sm"
                      onClick={() => history(`/orders/pending`)}
                    >
                      Pending Orders
                    </CButton>
                    <div className="fs-5 fw-semibold">{pendingOrders}</div>
                  </div>
                </CCol>
                <CCol sm={6}>
                  <div className="border-start border-start-4 border-start-success py-1 px-3 mb-3">
                    <CButton
                      color="outline-success"
                      className="mx-0"
                      size="sm"
                      onClick={() => history(`/orders/completed`)}
                    >
                      Completed Orders
                    </CButton>
                    <div className="fs-5 fw-semibold">{completedOrders}</div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm={6}>
                  <div className="border border-2 border-warning py-1 px-3 mb-3">
                    <div className="text-warning small">{formData?.orders} Pending Orders</div>
                    <div className="fs-5 fw-semibold">{pending}</div>
                  </div>
                </CCol>
                <CCol sm={6}>
                  <div className="border border-2 border-success py-1 px-3 mb-3">
                    <div className="text-success small">{formData?.orders} Completed Orders</div>
                    <div className="fs-5 fw-semibold">{completed}</div>
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard className="mb-2 shadow">
        <h5 className="card-title m-3">📊 Product Overview</h5>
        <CCardBody>
          <CRow className="mb-4">
            <CCol sm={3}>
              <CCard className="border border-danger text-center p-1 shadow-sm">
                <CIcon icon={cilBan} size="xl" className="text-danger mb-2" />
                <h6>Out of Stock</h6>
                <p className="fs-4 fw-bold text-danger">{outOfStock}</p>
              </CCard>
            </CCol>
            <CCol sm={3}>
              <CCard
                className="border border-success text-center p-1 shadow-sm"
                onClick={() => history(`/product/products`)}
                style={{ cursor: 'pointer' }}
              >
                <CIcon icon={cilStorage} size="xl" className="text-success mb-2" />
                <h6>Total Products</h6>
                <p className="fs-4 fw-bold">{totalProducts}</p>
              </CCard>
            </CCol>
            <CCol sm={3}>
              <CCard
                className="border border-info text-center p-1 shadow-sm"
                onClick={() => history(`/product/categories`)}
                style={{ cursor: 'pointer' }}
              >
                <CIcon icon={cilFolderOpen} size="xl" className="text-info mb-2" />
                <h6>Categories</h6>
                <p className="fs-4 fw-bold">{categories.length}</p>
              </CCard>
            </CCol>
            <CCol sm={3}>
              <CCard
                className="border border-info text-center p-1 shadow-sm"
                onClick={() => history(`/product/sub-categories`)}
                style={{ cursor: 'pointer' }}
              >
                <CIcon icon={cilApplications} size="xl" className="text-info mb-2" />
                <h6>Sub Categories</h6>
                <p className="fs-4 fw-bold">{subCategories.length}</p>
              </CCard>
            </CCol>
          </CRow>

          <CRow>
            <CCol md={4} className="mb-4">
              <h6>📦 Product Out of Stock</h6>
              <CTable striped bordered hover responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>ID</CTableHeaderCell>
                    <CTableHeaderCell>Product</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {productDetails.map((product, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{product.id}</CTableDataCell>
                      <CTableDataCell>{product.name}</CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CCol>

            <CCol md={4} className="mb-4">
              <h6>📂 Categories Product Count</h6>
              <CTable striped bordered hover responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>Category</CTableHeaderCell>
                    <CTableHeaderCell>Count</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {categories.map((category, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{category.name}</CTableDataCell>
                      <CTableDataCell>{category.count}</CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CCol>

            <CCol md={4}>
              <h6>📑 Subcategories Product Count</h6>
              <CTable striped bordered hover responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>Subcategory</CTableHeaderCell>
                    <CTableHeaderCell>Count</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {subCategories.map((subCategory, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{subCategory.name}</CTableDataCell>
                      <CTableDataCell>{subCategory.count}</CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Dashboard

/* <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h5 className="card-title mb-0">Proposal Request</h5>
            </CCol>
            <CCol sm={7} className="d-none d-md-block"></CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow xs={{ cols: 1 }} md={{ cols: 5 }} className="text-center">
            {progressProposal?.map((item, index) => (
              <CCol className="mb-sm-2 mb-0" key={index}>
                <div className="text-medium-emphasis">{item.title}</div>
                <strong>
                  {item.value} Request ({parseInt(item.percent)}%)
                </strong>
                <CProgress thin className="mt-2" color={item.color} value={item.percent} />
              </CCol>
            ))}
          </CRow>
        </CCardFooter>
      </CCard> */
/* <CRow>
<CCol sm={6}>
                      <div className="border-start border-start-4 border-start-primary py-1 px-3">
                        <CButton color="outline-secondary" className="mx-0" size="sm">
                          <div className="text-medium-emphasis">Total Subscription</div>
                        </CButton>
                        <div className="fs-5 fw-semibold">{subscriptionData?.package?}</div>
                      </div>
                    </CCol>
                  </CRow> 
                  
                  <hr className="" />
                  {progressRequest?.map((item, index) => (
                    <div className="progress-group" key={index}>
                      <div className="progress-group-header">
                        <CIcon
                          className="me-2"
                          icon={
                            item.icon === 'cilFilterPhoto'
                              ? cilFilterPhoto
                              : item.icon === 'cilEnvelopeClosed'
                              ? cilEnvelopeClosed
                              : item.icon === 'cilMobile'
                              ? cilMobile
                              : null
                          }
                          size="lg"
                        />
                        <span>{item.title}</span>
                        <span className="ms-auto fw-semibold">
                          {item.value}{' '}
                          <span className="text-medium-emphasis small">
                            ({parseInt(item.percent)}%)
                          </span>
                        </span>
                      </div>
                      <div className="progress-group-bars">
                        <CProgress thin color="success" value={item.percent} />
                      </div>
                    </div>
                  ))}*/
/* <CRow>
                    <CCol sm={6}>
                      <div className="border-start border-start-4 border-start-primary py-1 px-3">
                        <CButton color="outline-secondary" className="mx-0" size="sm">
                          <div className="text-medium-emphasis ">Total Package Approval</div>
                        </CButton>
                        <div className="fs-5 fw-semibold">{packages?.history?}</div>
                      </div>
                    </CCol>
                  </CRow>

                  <hr className="" />

                  {progressGender?.map((item, index) => (
                    <div className="progress-group mb-4" key={index}>
                      <div className="progress-group-header">
                        <CIcon
                          className="me-2"
                          icon={
                            item.icon === 'cilUser'
                              ? cilUser
                              : item.icon === 'cilUserFemale'
                              ? cilUserFemale
                              : null
                          }
                          size="lg"
                        />
                        <span>{item.title}</span>
                        <span className="ms-auto fw-semibold">
                          {item.value}{' '}
                          <span className="text-medium-emphasis small">
                            ({parseInt(item.percent)}%)
                          </span>
                        </span>
                      </div>
                      <div className="progress-group-bars">
                        <CProgress thin color={item.color} value={item.percent} />
                      </div>
                    </div>
))} */
